/* eslint-disable import/prefer-default-export */
import {
  SAVE_APPLICATION_START,
  SAVE_APPLICATION_SUCCESS,
  SAVE_APPLICATION_ERROR,
  DELETE_APPLICATION_START,
  DELETE_APPLICATION_SUCCESS,
  DELETE_APPLICATION_ERROR,
} from '../constants';

import { getSchool } from './schools';
import { saveProgram } from './saveProgram';
import fetchErrorHandler from '../services/fetchErrorHandler';
import { joinWaitlist } from './joinWaitlist';
import { getCsrfToken } from '../utils/helpers';

export const saveApplication = (
  directoryProgram,
  schoolId,
  schoolDbn,
  saved,
  savedProgramId,
  programData,
  rank,
) => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { applicationId } = getState().user;
  const { locale } = getState().intl;

  const currentResults =
    getState().user && getState().user.studentApplications && Array.isArray(getState().user.studentApplications.results)
      ? getState().user.studentApplications.results
      : [];
  const effectiveRank = typeof rank !== 'undefined' ? rank : currentResults.length + 1;

  const data = {
    directory_program: directoryProgram,
    application: applicationId,
    guardian: getState().user.guardianId,
    rank: effectiveRank,
  };
  const saveUrl = `${locale}/api/${apiVersion}/application/${applicationId}/application-programs/`;
  const deleteUrl = `${locale}/api/${apiVersion}/application/${applicationId}/application-programs/${savedProgramId}/`;
  const urlParameters = Object.entries(data)
    .map(e => `${encodeURIComponent(e[0])}=${encodeURIComponent(e[1])}`)
    .join('&');
  if (!saved) {
    dispatch({ type: SAVE_APPLICATION_START });

    return fetch(saveUrl, {
      credentials: 'include',
      headers: {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-CSRFToken': getCsrfToken(),
      },
      method: 'POST',
      body: urlParameters,
    })
      .then(fetchErrorHandler)
      .then(resp => resp.json())
      .then(respData => {
        dispatch({
          type: SAVE_APPLICATION_SUCCESS,
          payload: {
            applicationId,
            id: directoryProgram,
            schoolId,
            schoolDbn,
            respData,
            programData,
            rank: effectiveRank,
          },
        });
        return 'ADD_TO_APPLICATION_SUCCESS';
      })
      .catch(error => {
        dispatch({
          type: SAVE_APPLICATION_ERROR,
          payload: {
            error,
          },
        });
        return 'ADD_TO_APPLICATION_ERROR';
      });
  }
  dispatch({ type: DELETE_APPLICATION_START });
  return fetch(deleteUrl, {
    credentials: 'include',
    headers: {
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'DELETE',
  })
    .then(fetchErrorHandler)
    .then(resp => {
      dispatch({
        type: DELETE_APPLICATION_SUCCESS,
        payload: { applicationId, id: directoryProgram, schoolId },
      });
      return 'REMOVE_FROM_APPLICATION_SUCCESS';
    })
    .catch(error => {
      dispatch({
        type: DELETE_APPLICATION_ERROR,
        payload: {
          error,
        },
      });
      return 'REMOVE_FROM_APPLICATION_ERROR';
    });
};

export function addNewSchoolApplication(directoryProgram, schoolId, schoolDbn, saved, savedProgramId) {
  return dispatch =>
    dispatch(getSchool(schoolDbn)).then(() =>
      dispatch(saveApplication(directoryProgram, schoolId, schoolDbn, saved, savedProgramId)).then(
        dispatch(saveProgram(directoryProgram, schoolId, saved, savedProgramId)),
      ),
    );
}

export function addNewSchoolWaitlist(
  directoryProgram,
  schoolId,
  schoolDbn,
  saved,
  savedProgramId,
  isWaitlistJoinable = true,
) {
  return dispatch =>
    dispatch(getSchool(schoolDbn)).then(() =>
      dispatch(saveProgram(directoryProgram, schoolId, saved, savedProgramId)).then(
        dispatch(joinWaitlist(directoryProgram, schoolId, isWaitlistJoinable)),
      ),
    );
}
